import StorageLocationApi from "../../../api/modules/StorageLocationApi";

export const getAvailableLocations = async ({ commit }, payload) => {
  try {
    const { context, type } = payload;
    return await StorageLocationApi.getAvailableLocations(context, type);
  } catch (error) {
    console.error("Error al obtener ubicaciones:", error);
    throw error;
  }
};

export const getWarehouseShelfMap = async ({ commit }, payload) => {
  try {
    const { context, warehouse, floor } = payload;
    return await StorageLocationApi.getWarehouseShelfMap(context, warehouse, floor);
  } catch (error) {
    console.error("Error al obtener mapa de estantes:", error);
    throw error;
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/storageLocation/actions.js